import './rooms-header.scss';

export function RoomsHeader(){
    return (
        <div className="rooms-header">  
            <div className="header-info">
                <span className='header-text'>Hotel Janas, Tirupati</span>
                <span className='star-icons'>
                    <img src="star_icon.svg" alt='star' loading="lazy" decoding="async" />
                    <img src="star_icon.svg" alt='star' loading="lazy" decoding="async" />
                    <img src="star_icon.svg" alt='star' loading="lazy" decoding="async" />
                </span>
            </div>
        </div>
    )
}